import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Tooltip as MuiTooltip } from "@mui/material";
import dayjs from "dayjs";
import {
  getCashFlowCategories,
  getCategoryRowColors,
} from "./cashFlowCategories";

const CashFlowTable = ({ theme, days, data, formatValue }) => {
  const categorias = getCashFlowCategories(data, formatValue);

  const mapByDate = {};
  data.forEach((r) => {
    mapByDate[dayjs(r.fecha).format("YYYY-MM-DD")] = r;
  });

  return (
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              position: "sticky",
              left: 0,
              zIndex: 12,
              bgcolor: theme.palette.cashFlow,
              fontWeight: "bold",
              "&.MuiTableCell-head ": {
                minWidth: "25em",
                maxWidth: "25em",
              },
            }}
          >
            Concepto
          </TableCell>
          {days.map((d) => {
            const weekday = dayjs(d).day();
            const isWeekend = weekday === 0 || weekday === 6;
            return (
              <TableCell
                key={d}
                sx={{
                  bgcolor: isWeekend ? theme.palette.error.light : undefined,
                  color: isWeekend ? theme.palette.grey[200] : undefined,
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                }}
              >
                {dayjs(d).format("DD/MM")}
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {categorias.map((cat) => {
          const { rowBg, stickyBg } = getCategoryRowColors(theme, cat.key);
          const label =
            typeof cat.label === "string" ? cat.label : cat.mobileLabel;

          return (
            <TableRow key={cat.key} sx={{ bgcolor: rowBg }}>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  bgcolor: stickyBg,
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  "&.MuiTableCell-root": {
                    width: "25em",
                  },
                }}
              >
                {label}
              </TableCell>
              {days.map((d) => {
                const cellValue = mapByDate[d]?.[cat.key];
                const clientes = mapByDate[d]?.clientes;
                return (
                  <TableCell
                    key={d}
                    sx={{
                      fontSize: "0.8rem",
                      textAlign: "right",
                      fontWeight: "bold",
                      color:
                        cellValue < 0 ? theme.palette.error.main : undefined,
                      bgcolor: rowBg,
                      cursor:
                        cat.key === "facturasVenta" && clientes?.length
                          ? "pointer"
                          : "default",
                    }}
                  >
                    {cat.key === "facturasVenta" && clientes?.length ? (
                      <MuiTooltip
                        title={
                          <div>
                            {clientes.map((c, idx) => (
                              <div key={idx}>
                                {c.nombre}: {formatValue(c.importe)}
                              </div>
                            ))}
                          </div>
                        }
                        arrow
                        placement="top"
                      >
                        <span>{formatValue(cellValue ?? 0)}</span>
                      </MuiTooltip>
                    ) : (
                      formatValue(cellValue)
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default CashFlowTable;
